<template>
    <div id="contenedor-main-proyectos-documentos">
        <listado-proyecto-documentos-desktop
        :idProyecto="idProyecto">

        </listado-proyecto-documentos-desktop>
    </div>
</template>

<script>
import ListadoProyectoDocumentosDesktop from '@/components/administracion/control-proyectos/documentos/listado/Desktop.vue';

export default {
  name: 'MainControlProyectosDocumentos',
  components: {
    ListadoProyectoDocumentosDesktop,

  },
  data() {
    return {
      idProyecto: this.$route.params.idProyecto,
    };
  },

};
</script>

<style lang="scss" scoped>

</style>
